import React, { PropsWithChildren, useContext, useEffect, useMemo, useState } from 'react';
import { loadEmails } from '../notifications';
import type { ITemplate } from '../notifications';

interface IProps {
  emails: ITemplate[];
}

const defaultValue: IProps = {
  emails: [],
};

const ENotificationsContext = React.createContext<IProps>(defaultValue);

export function ENotificationsContextProvider({ children }: PropsWithChildren) {
  const [emails, setEmails] = useState<ITemplate[]>([]);

  useEffect(() => {
    setEmails(loadEmails());
  }, []);

  const memoizedValue: IProps = useMemo(
    () => ({
      emails,
    }),
    [emails],
  );

  return <ENotificationsContext.Provider value={memoizedValue}>{children}</ENotificationsContext.Provider>;
}

export const useENotificationsContext = (): IProps => useContext(ENotificationsContext);
